import React from "react";
import styled from "styled-components";

const StyledSvg = styled.svg`
  fill: rgba(255, 255, 255, 0.7);
  &:hover {
    fill: #007672;
    stroke: #007672;
    stroke-width: 1;
  }
`;

const TemperatureIcon = () => (
  <StyledSvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9 12V5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2C12.7957 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V12C16.1439 12.6604 17.0378 13.6798 17.5433 14.9001C18.0487 16.1203 18.1374 17.4733 17.7956 18.7491C17.4537 20.0249 16.7004 21.1522 15.6526 21.9563C14.6047 22.7603 13.3208 23.1962 12 23.1962C10.6792 23.1962 9.3953 22.7603 8.34743 21.9563C7.29957 21.1522 6.5463 20.0249 6.20445 18.7491C5.8626 17.4733 5.95127 16.1203 6.45673 14.9001C6.96218 13.6798 7.85615 12.6604 9 12ZM10.5 11H13.5V5C13.5 4.60218 13.342 4.22064 13.0607 3.93934C12.7794 3.65804 12.3978 3.5 12 3.5C11.6022 3.5 11.2206 3.65804 10.9393 3.93934C10.658 4.22064 10.5 4.60218 10.5 5V11ZM10.5 7H13.5V11H10.5V7Z' />
  </StyledSvg>
);

export default TemperatureIcon;
